/**
 * PanelHeader
 * Shared header component with icon and title for panel components
 */

import { makeStyles, tokens, Text } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  icon: {
    fontSize: '16px',
    color: tokens.colorNeutralForeground2,
  },
  title: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
})

export interface PanelHeaderProps {
  icon: React.ReactNode
  title: string
}

export function PanelHeader({ icon, title }: PanelHeaderProps) {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <span className={styles.icon}>{icon}</span>
      <Text className={styles.title}>{title}</Text>
    </div>
  )
}
